import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=00530e74&scoped=true&"
import script from "./Cookies.vue?vue&type=script&lang=js&"
export * from "./Cookies.vue?vue&type=script&lang=js&"
import style0 from "./Cookies.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Cookies.vue?vue&type=style&index=1&id=00530e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00530e74",
  null
  
)

export default component.exports